import {FormElementType} from "~/enums/formElementType";
const stateOptions = [
  {label_title: "Alabama", value: "AL"},
  {label_title: "Alaska", value:"AK"},
  {label_title: "Arizona", value:"AZ"},
  {label_title: "Arkansas", value:"AR"},
  {label_title: "California", value:"CA"},
  {label_title: "Colorado", value:"CO"},
  {label_title: "Connecticut", value:"CT"},
  {label_title: "Delaware", value:"DE"},
  {label_title: "District of Columbia", value:"DC"},
  {label_title: "Florida", value:"FL"},
  {label_title: "Georgia", value:"GA"},
  {label_title: "Hawaii", value:"HI"},
  {label_title: "Idaho", value:"ID"},
  {label_title: "Illinois", value:"IL"},
  {label_title: "Indiana", value:"IN"},
  {label_title: "Iowa", value:"IA"},
  {label_title: "Kansas", value:"KS"},
  {label_title: "Kentucky", value:"KY"},
  {label_title: "Louisiana", value:"LA"},
  {label_title: "Maine", value:"ME"},
  {label_title: "Maryland", value:"MD"},
  {label_title: "Massachusetts", value:"MA"},
  {label_title: "Michigan", value:"MI"},
  {label_title: "Minnesota", value:"MN"},
  {label_title: "Mississippi", value:"MS"},
  {label_title: "Missouri", value:"MO"},
  {label_title: "Montana", value:"MT"},
  {label_title: "Nebraska", value:"NE"},
  {label_title: "Nevada", value:"NV"},
  {label_title: "New Hampshire", value:"NH"},
  {label_title: "New Jersey", value:"NJ"},
  {label_title: "New Mexico", value:"NM"},
  {label_title: "New York", value:"NY"},
  {label_title: "North Carolina", value:"NC"},
  {label_title: "North Dakota", value:"ND"},
  {label_title: "Ohio", value:"OH"},
  {label_title: "Oklahoma", value:"OK"},
  {label_title: "Oregon", value:"OR"},
  {label_title: "Pennsylvania", value:"PA"},
  {label_title: "Rhode Island", value:"RI"},
  {label_title: "South Carolina", value:"SC"},
  {label_title: "South Dakota", value:"SD"},
  {label_title: "Tennessee", value:"TN"},
  {label_title: "Texas", value:"TX"},
  {label_title: "Utah", value:"UT"},
  {label_title: "Vermont", value:"VT"},
  {label_title: "Virginia", value:"VA"},
  {label_title: "Washington", value:"WA"},
  {label_title: "West Virginia", value:"WV"},
  {label_title: "Wisconsin", value:"WI"},
  {label_title: "Wyoming", value:"WY"}
];

export class StateDropdownSchema {

  static _stateDropdownOptions: any;

  static stateDropdownOptions(mergeJson: object = {}) {
    let baseJson: object;
    if (!this._stateDropdownOptions) {
      this._stateDropdownOptions = stateOptions.map((e, ind) => {
        let json = e;
        json['sort_order'] = ind;
        baseJson = {
          formElementType: FormElementType.dropdownItem,
          json: json,
        };
        if (mergeJson) {
          return Object.assign(baseJson, mergeJson);
        } else {
          return baseJson;
        }
      });
    }
    return this._stateDropdownOptions;
  }
}

export const stateDropdownItems = StateDropdownSchema.stateDropdownOptions();